import { createSlice } from "@reduxjs/toolkit";

const chapterDataSlice = createSlice({
    name: 'chapters',
    initialState: {data: {},status: ''},
    reducers: {
        chapters(state, action){
            state.data      = action.payload.data
            state.status    = action.payload.status
        },
    },
});

export const chapterDataActions = chapterDataSlice.actions;
export default chapterDataSlice.reducer;